import { settings } from '../../settings';
import area from './area';
import areaDispositions from './areaDispositions';
import areaList from './areaList';
import areas from './areas';
import areaTeamList from './areaTeamList';
import polygonPreview from './polygonPreview';
import polygonsStatistics from './polygonsStatistics';
import team from './team';
import teamCells from './teamCells';
import teamDispositions from './teamDispositions';
import teamPins from './teamPins';
import teamPolygons from './teamPolygons';
import teamReps from './teamReps';
import teams from './teams';
const reducers = () => ({
    [`${settings.uid}/area`]: area,
    [`${settings.uid}/areaDispositions`]: areaDispositions,
    [`${settings.uid}/areaList`]: areaList,
    [`${settings.uid}/areas`]: areas,
    [`${settings.uid}/areaTeamList`]: areaTeamList,
    [`${settings.uid}/polygonPreview`]: polygonPreview,
    [`${settings.uid}/polygonsStatistics`]: polygonsStatistics,
    [`${settings.uid}/team`]: team,
    [`${settings.uid}/teamCells`]: teamCells,
    [`${settings.uid}/teamDispositions`]: teamDispositions,
    [`${settings.uid}/teamPins`]: teamPins,
    [`${settings.uid}/teamPolygons`]: teamPolygons,
    [`${settings.uid}/teamReps`]: teamReps,
    [`${settings.uid}/teams`]: teams,
});
export default reducers;
